import SitePhoto from '@/components/Photo'
import { localizeHref } from '@/i18n/href'
import { useI18n } from '@/i18n/I18nProvider'
import type { SectionOf } from './shared'

export default function FigureSection({ section }: { section: SectionOf<'figure'> }) {
  const { locale } = useI18n()
  const photo = (
    <SitePhoto
      photo={section.photo}
      sizes="(max-width: 1024px) 92vw, 1024px"
      className="h-auto w-full"
    />
  )
  return (
    <figure className="mx-auto max-w-5xl">
      {/* Never cropped, unlike `photo` above — see the note on the section
          kind. A wheel is 2.4:1 with its dimension names printed down both
          edges, so it keeps its own ratio and fills the width.

          It scales to the column whole at every width rather than scrolling
          sideways (2026-08-28, asked for) — the same treatment every chart
          on the DAIMI report pages now gets. The labels are small on a
          phone, but a diagram the reader has to drag reads as broken, and
          one seen in halves is worse than one seen small. */}
      <div>
        {/* Clickable only when `href` is set — no border, no hover state, so
            the drawing looks exactly as it did; the cursor is the only tell. */}
        {section.href ? (
          <a href={localizeHref(section.href, locale)}>{photo}</a>
        ) : (
          photo
        )}
      </div>
      {section.caption && (
        <figcaption className="mt-4 text-sm text-muted-foreground">{section.caption}</figcaption>
      )}
    </figure>
  )
}
